import { Box, styled } from '@mui/material';

export const StyledAppointmentsBookingItemWrap = styled(Box)(() => ({
	paddingInline: '4px',
	borderRadius: '3px',
	display: 'flex',
	alignItems: 'center',
	WebkitTapHighlightColor: 'transparent',
	height: '100%',
}));

export default StyledAppointmentsBookingItemWrap;
